import React, { useState } from "react";
import classNames from "classnames";

import ICONS from "../constants/icons";
import Tag from "./Tag";
import { FilterProps } from "./types";
import { useAppContext } from "../../context/AppContext";

import styles from "./productFilters.module.css";

//This component has two types, one with filters and one with info (for the product detail page)
const FilterDropdown = ({
  title,
  filters,
  onClick,
  additionalHidden = [],
  activeFilters,
}: FilterProps) => {
  const [open, setOpen] = useState(false);
  const { hiddenFilters } = useAppContext();

  return (
    <div
      className={classNames(styles.filterDropdown, {
        [styles.filterDropdownOpen]: open,
      })}
    >
      <div
        className={styles.title}
        onClick={() => {
          setOpen(!open);
        }}
      >
        {title}

        <ICONS.ARROWUP size={24} />
      </div>

      {open &&
        filters.map((tag, index) => {
          if (
            ![...hiddenFilters, ...additionalHidden].includes(
              tag.name.toLowerCase()
            )
          ) {
            return (
              <Tag
                isFilter
                key={index}
                filter={tag}
                onClick={onClick}
                selected={activeFilters.indexOf(tag.value) > -1}
              />
            );
          }
        })}
    </div>
  );
};

export default FilterDropdown;
